import React from "react";
import { Container } from "@mui/material";
import Chip from "@mui/material/Chip";
import { Slide } from "react-slideshow-image";
import whyskyimg from "../Images/WHYSKY.webp";
import img1 from "../Images/Testimonials/1.jpg";
import img2 from "../Images/Testimonials/4.jpg";
import img3 from "../Images/Testimonials/6.jpg";
import img4 from "../Images/Testimonials/8.jpg";
import img5 from "../Images/Testimonials/10.jpg";
import img6 from "../Images/Testimonials/11.jpg";
import img7 from "../Images/Testimonials/12.jpg";
import img8 from "../Images/Testimonials/14.jpg";
import img9 from "../Images/Testimonials/16.jpg";
import img10 from "../Images/Testimonials/18.jpg";
import img11 from "../Images/Testimonials/20.jpg";
import img12 from "../Images/Testimonials/21.jpg";
import img13 from "../Images/Testimonials/23.jpg";
import img14 from "../Images/Testimonials/25.jpg";
import img15 from "../Images/Testimonials/26.jpg";
import img16 from "../Images/Testimonials/28.jpg";
import img17 from "../Images/Testimonials/30.jpg";
import img18 from "../Images/Testimonials/32.jpg";
import img19 from "../Images/Testimonials/34.jpg";
import img20 from "../Images/Testimonials/36.jpg";
import img21 from "../Images/Testimonials/38.jpg";
import img22 from "../Images/Testimonials/40.jpg";
import img23 from "../Images/Testimonials/42.jpg";
import img24 from "../Images/Testimonials/44.jpg";
import img25 from "../Images/Testimonials/46.jpg";
import "../styles/slider.css";

function Meditate() {
  const slideImages = [
    img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12,
    img13, img14, img15, img16, img17, img18, img19, img20, img21, img22,
    img23, img24, img25,
  ];

  const properties = {
    duration: 5000,
    autoplay: true,
    indicators: true,
  };

  return (
    <main className="meditate-page">
      <div className="slide-container meditate-page__slider">
        <Slide {...properties}>
          {slideImages.map((slideImage, index) => (
            <div className="each-slide" key={index}>
              <img
                alt={`Art of Living community testimonial ${index + 1}`}
                src={slideImage}
              />
            </div>
          ))}
        </Slide>
      </div>

      <section className="meditate-page__testimonials">
        <Container maxWidth="md">
          <h1>How is Art of Living changing lives?</h1>
          <p>Hear directly from people who have taken part in the programs.</p>
          <Chip
            label="Watch video testimonials"
            component="a"
            href="https://linktr.ee/video.testimonials"
            color="primary"
            target="_blank"
            rel="noopener noreferrer"
            clickable
          />
        </Container>
      </section>

      <section
        className="meditate-impact"
        style={{ backgroundImage: `url(${whyskyimg})` }}
      >
        <div className="meditate-impact__content">
          <h2>Impact of SKY on health and wellbeing</h2>
          <p>
            Explore the science-backed benefits of SKY, taught in the Art of
            Living Part 1 program and studied by independent researchers.
          </p>
        </div>
      </section>
    </main>
  );
}

export default Meditate;
